module.exports = __webpack_public_path__ + "img/9.ef027f8e.png";